/* Ace Chef — Symmetry-style theme scripts */

/* hero slider: each slide carries its own overlay text */
(function(){
  var hero=document.querySelector('.hero');
  if(!hero)return;
  var slides=[].slice.call(hero.querySelectorAll('.slide'));
  var dots=[].slice.call(hero.querySelectorAll('.hero-dots button'));
  if(slides.length<2){return;}
  var i=0,timer,delay=parseInt(hero.getAttribute('data-interval'),10)||5000;
  function show(n){
    i=(n+slides.length)%slides.length;
    slides.forEach(function(s,k){s.classList.toggle('active',k===i)});
    dots.forEach(function(d,k){d.classList.toggle('on',k===i)});
  }
  function next(){show(i+1)}
  function start(){clearInterval(timer);timer=setInterval(next,delay)}
  dots.forEach(function(d,k){d.addEventListener('click',function(){show(k);start()})});
  show(0);start();
})();

/* mobile menu toggle */
(function(){
  var btn=document.getElementById('navToggle'),drawer=document.getElementById('navMobile');
  if(!btn||!drawer)return;
  btn.addEventListener('click',function(){drawer.classList.toggle('open')});
})();

/* transparent -> solid header on scroll */
(function(){
  var h=document.querySelector('header.site');
  if(!h)return;
  function onScroll(){h.classList.toggle('stuck',window.scrollY>30)}
  window.addEventListener('scroll',onScroll,{passive:true});
  onScroll();
})();

/* chef choices carousel */
(function(){
  var track=document.getElementById('chefTrack');
  if(!track)return;
  var prev=document.getElementById('chefPrev'),next=document.getElementById('chefNext');
  function step(){
    var card=track.querySelector('.prod');
    var w=card?card.offsetWidth+24:320;
    return Math.max(w, Math.floor(track.clientWidth/w)*w);
  }
  function update(){
    var max=track.scrollWidth-track.clientWidth-2;
    if(prev)prev.style.opacity=track.scrollLeft<=2?.35:1;
    if(next)next.style.opacity=track.scrollLeft>=max?.35:1;
  }
  if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'})});
  if(next)next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'})});
  track.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update);
  update();
})();

/* video reels: tap to toggle sound */
(function(){
  document.querySelectorAll('.vid').forEach(function(card){
    var v=card.querySelector('video'),ic=card.querySelector('.sound');
    if(!v)return;
    function toggle(){
      v.muted=!v.muted;
      if(!v.muted){v.play();document.querySelectorAll('.vid video').forEach(function(o){if(o!==v){o.muted=true;}});document.querySelectorAll('.vid .sound').forEach(function(s){if(s!==ic)s.textContent='🔇';});}
      if(ic)ic.textContent=v.muted?'🔇':'🔊';
    }
    if(ic)ic.addEventListener('click',function(e){e.stopPropagation();toggle();});
    v.addEventListener('click',toggle);
  });
})();
